import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './FooterRowLayout.scss';
const FooterRowLayout = (_param)=>{
    var { blocks, className } = _param, rest = _object_without_properties(_param, [
        "blocks",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread({
        className: c(s['root'], className)
    }, rest), blocks);
};
FooterRowLayout.displayName = 'FooterRowLayout';
export default FooterRowLayout;
